import { Http } from "@/util";

/**
 * 创建或更新司机公告模板
 */
export function createOrUpdateAnnouncementTemplate(param) {
  return Http.post("/admin/driver/notice/create/announcement/template", param);
}

/**
 * 删除司机公告模板
 */
export function deleteAnnouncementTemplate(templateId) {
  return Http.get("/admin/driver/notice/delete/announcement/template", { templateId });
}

/**
 * 发送司机公告
 */
export function sendDriverAnnouncement(param) {
  return Http.post("/admin/driver/notice/send/announcement", param);
}

/**
 * 查询司机公告模板列表
 */
export function getAnnouncementTemplateList(param) {
  return Http.post("/admin/driver/notice/get/announcement/template", param);
}

/**
 * 查询司机公告已读状态
 */
export function getDriverAnnouncementReadStats(templateId) {
  return Http.get("/admin/driver/notice/get/announcement/read/stats", { templateId });
}
